






















	import { Component, Vue } from 'vue-property-decorator';
	import { Action, State, namespace } from 'vuex-class';

	/**
	 * Utils
	 */
	import { sortByAsc } from "@/utils/sort-helpers";

	/**
	 * Mixins
	 */
	import mixinsAPI from "@/mixins/api-mixins";

	/**
	 * Components
	 */
	import BookingCalendar from "./components/BookingCalendar.vue";

	/**
	 * API
	 */
	import bookingsAPI from "@/api/bookings";
	import usersAPI from "@/api/users";
	import servicesAPI, { ModePassage } from "@/api/services";
	import subscriptionsAPI from "@/api/subscriptions";

	/**
	 * Types
	 */
	import { SettingsResponseModel } from '@/api/settings';

	/**
	 * VueX Modules
	 */
	const clientSettingsModule = namespace('settings');

	/**
	 * Page de réservation de passages.
	 */
	@Component({
		components: { BookingCalendar },
		mixins: [mixinsAPI]
	})
	export default class BookingPage extends Vue {
		$refs!: {
			calendar: BookingCalendar
		};

		/** VueX - Settings */
		@clientSettingsModule.Getter
		settings!: SettingsResponseModel;

		/** VueX - Snackbar */
		@Action('openInfo', { namespace: 'snackbar' })
		openInfo: any;
		@Action('openError', { namespace: 'snackbar' })
		openError: any;

		/** Attributs */
		isLoading = false;
		isActionLoading = false;

		// Les usagers possibles
		users: any[] = [];

		// Les services possibles
		services: any[] = [];

		/** Méthodes */
		async created() {
			this.isLoading = true;
			await this.loadFilterDefinitionsData();
			this.isLoading = false;
		}

		async loadFilterDefinitionsData() {
			const currentUser = await usersAPI.getCurrent();
			const currentUserChildren = await usersAPI.getChildrenForBooking();
			const services = await servicesAPI.getAll(ModePassage.PASSAGES);

			this.users = [
				currentUser,
				...currentUserChildren
			];

            this.services = services.sort(sortByAsc((x) => x.label));
		}

		async fetchMonthScheduledEntries(month: number, year: number) {
			return await subscriptionsAPI.getMonthScheduledEntries(month, year);
		}

		async fetchMonthBookableDates(month: number, year: number) {
			return await bookingsAPI.getAllowedMonthBookableDates(month, year);
		}

		async fetchMonthBookings(month: number, year: number) {
			return await bookingsAPI.getAll(year, month, null);
		}

		/**
		 * Callback lorsque l'on clique sur "Réserver".
		 */
		async handleBookClick(date: Date, userID: number, serviceID: number) {
			this.isActionLoading = true;
			try {
				await bookingsAPI.create({
					bookedDate: date,
					isBooking: true,
					userID: userID,
					serviceID: serviceID
				});

				await this.$refs.calendar.reloadBookings();

				this.openInfo(this.$t('snackbar.success'));
			}
			catch (err) {
				(this as any).handleAPIError(err);
			}
			this.isActionLoading = false;
		}

		/**
		 * Callback lorsque l'on clique sur "Déréserver".
		 */
		async handleUnbookClick(date: Date, userID: number, serviceID: number) {
			this.isActionLoading = true;
			try {
				await bookingsAPI.create({
					bookedDate: date,
					isBooking: false,
					userID,
					serviceID
				});

				await this.$refs.calendar.reloadBookings();

				this.openInfo(this.$t('snackbar.success'));
			}
			catch (err) {
				(this as any).handleAPIError(err);
			}
			this.isActionLoading = false;
		}

		/**
		 * Callback lorsque l'on clique sur "Annuler" une réservation ou "Annuler" une déréservation.
		 */
		async handleCancelClick(date: Date, userID: number, serviceID: number) {
			this.isActionLoading = true;
			try {
				await bookingsAPI.cancel({
					bookedDate: date,
					userID,
					serviceID,
					hasItems: false
				});

				await this.$refs.calendar.reloadBookings();

				this.openInfo(this.$t('snackbar.success'));
			}
			catch (err) {
				(this as any).handleAPIError(err);
			}
			this.isActionLoading = false;
		}
	}
